import { render, staticRenderFns } from "./TheLoadingIndicator.vue?vue&type=template&id=a45b05da&"
import script from "./TheLoadingIndicator.vue?vue&type=script&lang=ts&"
export * from "./TheLoadingIndicator.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports